import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookie from "cookie-universal";
import { baseURL } from "../../Api/Api";
const cookie = Cookie();

export const getAllUsers = createAsyncThunk(
  "users/getall",
  async ({ name = "", page = 1, limit = 10 } = {}, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.get(`${baseURL}/Admin-users?name=${name}&page=${page}&limit=${limit}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth?.token}`,
        },
      });

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const getUser = createAsyncThunk(
  "users/getUser",
  async (value, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.get(`${baseURL}/Admin-users/${value}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth?.token}`,
        },
      });

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const addUser = createAsyncThunk(
  "users/getUser",
  async (values, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.post(`${baseURL}/Admin-users`, values, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${auth?.token}`,
        },
      });

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const makeUserNormalize = createAsyncThunk(
  "users/makeusernormalize",
  async ({ id, verified }, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const formData = new FormData();
      const response = await axios.post(
        `${baseURL}/Admin-users/${id}`,
        { _method: "PATCH", status: verified ? 1 : 0 },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const getUsersVerified = createAsyncThunk(
  "users/verified",
  async ({ type, value, page = 1, limit = 10 }, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.get(
        `${baseURL}/Admin-users?type=${type}&name=${value}&page=${page}&limit=${limit}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const makeUserWarning = createAsyncThunk(
  "users/makeWarning",
  async ({ user_id }, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.post(
        `${baseURL}/Admin-users-warning`,
        { user_id, text: "make user warning" },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);
export const makeUserBanned = createAsyncThunk(
  "users/makeBanned",
  async ({ user_id, date }, { rejectWithValue, getState }) => {
    const { auth } = getState();
    try {
      const response = await axios.post(
        `${baseURL}/Admin-users-ban`,
        { user_id, text: "make user banned", expiry_date: date },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${auth?.token}`,
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }

      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  userDetails: {},
  allUsers: [],
  meta: null,
  isWarning: false,
  isNormalize: false,
  isBanned: false,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    reset(state) {
      state.loading = false;
      state.error = null;
      state.isWarning = false;
      state.isNormalize = false;
      state.isBanned = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllUsers.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload?.data;
        state.meta = action.payload?.meta;
        state.error = null;
      })
      .addCase(getAllUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })

      .addCase(getUsersVerified.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUsersVerified.fulfilled, (state, action) => {
        state.loading = false;
        state.allUsers = action.payload?.data;
        state.meta = action.payload?.meta;
        state.error = null;
      })
      .addCase(getUsersVerified.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(getUser.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = action.payload?.data;
        state.error = null;
      })
      .addCase(getUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(makeUserNormalize.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(makeUserNormalize.fulfilled, (state, action) => {
        state.loading = false;
        state.isNormalize = true;
        state.error = null;
      })
      .addCase(makeUserNormalize.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(makeUserWarning.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(makeUserWarning.fulfilled, (state, action) => {
        state.loading = false;
        state.isWarning = true;
        state.error = null;
      })
      .addCase(makeUserWarning.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(makeUserBanned.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(makeUserBanned.fulfilled, (state, action) => {
        state.loading = false;
        state.isBanned = true;
        state.error = null;
      })
      .addCase(makeUserBanned.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      });
  },
});

export const { reset } = usersSlice.actions;
const usersReducer = usersSlice.reducer;

export default usersReducer;
